<p-scroll-panel class="h-full">
  <div [formGroup]="form">
    <div class="flex gap-10">
      <div style="width: 700px">
        <div class="control required">
          <label>Status</label>
          <p-select
            [options]="vistStatusOptions"
            class="w-[178px]"
            formControlName="vistStatus"
            optionLabel="text"
            optionValue="value"
            appendTo="body" />
        </div>
        <div class="control required">
          <label>Emne</label>
          <input pInputText formControlName="emne" />
        </div>
        <div class="control required">
          <label>Indhold</label>
          <p-editor
            #editor
            formControlName="indhold"
            [style]="{ height: '250px' }">
            <ng-template #header>
              <span class="ql-formats">
                <button
                  type="button"
                  class="ql-bold"
                  aria-label="Bold"></button>
                <button
                  type="button"
                  class="ql-italic"
                  aria-label="Italic"></button>
                <button
                  type="button"
                  class="ql-underline"
                  aria-label="Underline"></button>
              </span>
              <span class="ql-formats">
                <button
                  type="button"
                  value="ordered"
                  class="ql-list"
                  aria-label="Bullet"></button>
                <button
                  type="button"
                  value="bullet"
                  class="ql-list"
                  aria-label="Bullet"></button>
              </span>
              <span class="ql-formats">
                <button
                  type="button"
                  class="ql-link"
                  aria-label="Bullet"></button>
              </span>
            </ng-template>
          </p-editor>
        </div>
        <div class="control required">
          <label>Kommentar</label>
          <textarea pTextarea formControlName="kommentar"></textarea>
        </div>
      </div>
      <div class="flex-1">
        <div class="control required">
          <label>Status</label>
          <p-select
            [options]="redigeringsStatusOptions"
            class="w-[178px]"
            formControlName="redigeringsStatus"
            optionLabel="text"
            optionValue="value"
            appendTo="body" />
        </div>
        <div class="control required">
          <label>Starttidspunkt</label>
          <app-let-date-picker formControlName="start" [showTime]="true" />
        </div>
        <div class="control required">
          <label>Sluttidspunkt</label>
          <app-let-date-picker formControlName="slut" [showTime]="true" />
        </div>
        <div class="control">
          <label>Produkter</label>
          <p-multiselect
            [options]="produktTypeService.produktTypeMedNavnOptions()"
            display="chip"
            [maxSelectedLabels]="10"
            scrollHeight="400px"
            optionValue="value"
            optionLabel="text"
            [showClear]="true"
            formControlName="produkter"
            appendTo="body" />
        </div>
        <div class="control">
          <label>Regnr</label>
          <input pInputText formControlName="regNr" />
        </div>
        <div class="control required">
          <label>ITC</label>
          <p-select
            [options]="itcOptions"
            class="w-[178px]"
            formControlName="itc"
            appendTo="body" />
        </div>
        <div class="control required">
          <label>System</label>
          <p-multiselect
            [options]="systemOptions"
            display="chip"
            [maxSelectedLabels]="10"
            scrollHeight="400px"
            formControlName="driftsystem"
            optionLabel="text"
            optionValue="value"
            appendTo="body" />
        </div>
      </div>
    </div>
    <div class="flex gap-4">
      <p-button
        label="Gem ændringer"
        icon="pi pi-save"
        (click)="onClickSave()"
        [disabled]="!form.valid" />
      <p-button
        label="Slet meddelelse"
        icon="pi pi-trash"
        severity="danger"
        outlined
        (click)="onClickDelete($event)" />
    </div>
  </div>

  @let apiResponse = historikData.value();
  @if (apiResponse) {
    <div class="mb-2 mt-8">
      <h3>Historik</h3>
      <p-table
        [value]="apiResponse.data"
        stripedRows
        [loading]="historikData.isLoading()"
        [scrollable]="true"
        scrollHeight="400px"
        class="p-datatable-sm lp-table">
        <ng-template pTemplate="header">
          <tr>
            <th>Tidspunkt</th>
            <th>Bruger</th>
            <th>Kommentar</th>
            <th>Ændringer</th>
          </tr>
        </ng-template>
        <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-hist>
          <tr>
            <td class="numbers">
              {{ hist.tidspunkt | date: 'dd-MM-yyyy HH:mm' }}
            </td>
            <td>{{ hist.brugerNavn }}</td>
            <td>{{ hist.kommentar }}</td>
            <td>{{ hist.systemKommentar }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</p-scroll-panel>
<p-confirmDialog />
